import { EMPTY_STRING } from './constants';

function RequiredProp(propName = EMPTY_STRING) {
  return new Error(`Error: ${propName} is required`);
}

export default RequiredProp;
